<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="flex flex-wrap max-h-full bg-white shadow-lg rounded-lg w-3/6 px-5 pb-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 z-50 bg-white pt-5">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="w-full px-4 py-2 h-full">
          <div class="w-full">
            <div class="flex">
              <h1
                class="pb-1 text-left font-bold tracking-widest text-neutral-100"
              >
                {{ currentProject.titulo }}
              </h1>
            </div>
            <div v-if="has_geometry" class="flex">
              <div class="h-80 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="4"
                  :center="center"
                  :options="{ zoomControl: false }"
                  @ready="onMapReady"
                >
                  <l-tile-layer
                    :url="urlBasemap"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
                </l-map>
              </div>
            </div>
            <div class="flex w-full">
              <div
                class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
              >
                <div class="flex items-center">
                  <div class="flex items-center w-1/2 text-left text-xs">
                    <div
                      v-if="currentProject.status === 'NO REVISADO'"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} EN PROCESO
                    </div>
                    <div
                      v-if="currentProject.status === 'RECHAZADO'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'EN REVISIÓN'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'APROBADO'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div class="pl-2">
                      <div
                        v-if="currentProject.activo === true"
                        class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                      >
                        Activo
                      </div>
                      <div
                        v-if="currentProject.activo === false"
                        class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                      >
                        Desactivado
                      </div>
                    </div>
                  </div>
                  <div class="w-1/2 text-right text-xs text-gray-900">
                    {{
                      currentProject.fecha_creacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Nombre del proyecto:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Institución:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.institucion }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Líder de proyecto:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.lider }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Descripción:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.descripcion }}
                  </div>
                </div>

<!--                 <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Objetivo:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.objetivo }}
                  </div>
                </div> -->

<!--                 <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold"
                      >Especificaciones de la fotografía:</span
                    >
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.especificaciones_multimedia }}
                  </div>
                </div> -->

<!--                 <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Producto:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.producto }}
                  </div>
                </div> -->

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Creado por:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_propietario }}
                    {{ currentProject.apellido_propietario }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de creación:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{
                      currentProject.fecha_creacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Desactivado por:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_curador_desactivate }}
                    {{ currentProject.apellido_curador_desactivate }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de desactivación:</span>
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{
                      currentProject.fecha_desactivacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.id_curador !== null"
                >
                  <div
                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span
                      class="font-bold"
                      v-if="currentProject.status !== 'NO REVISADO'"
                      >Atendido por:</span
                    >
                  </div>
                  <div
                    class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                  >
                    {{ currentProject.nombre_curador }}
                    {{ currentProject.apellido_curador }}
                  </div>
                </div>

                <div
                  v-if="currentProject.file_type == 'video/mp4'"
                  class="flex justify-center py-2 w-full"
                >
                  <video
                    :src="currentProject.path_media_folder"
                    width="640"
                    height="480"
                    controls
                    controlslist="nodownload"
                  />
                </div>
                <div class="flex justify-center py-2 w-8/12 mx-auto">
                  <v-lazy-image :src="currentProject.path_media_folder" />
                </div>
                <p
                  v-if="currentProject.ficha_proyecto"
                  class="pb-1 pt-2 text-sm text-left font-bold tracking-widest"
                >
                  Ficha de información:
                </p>
                <div
                  v-for="one_question in currentQuestions"
                  :key="one_question.id"
                >
                  <div v-if="one_question.texto != null">
                    <label
                      class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                      >{{ one_question.id_pregunta }}.-
                      {{ one_question.texto }}
                      <template v-if="one_question.nota_para_registrante != ''">
                        ({{ one_question.nota_para_registrante }})
                      </template>
                    </label>

                    <div v-if="one_question.tipo === 'ABIERTA'">
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        value=""
                        disabled
                      />
                    </div>

                    <template v-if="one_question.tipo == 'SELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>
                    </template>

                    <template
                      v-if="one_question.tipo == 'SELECCION_CONDICIONAL'"
                    >
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            :value="opt"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <template
                        v-for="(opt, index) in one_question.pregunta_condicion"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.id }}.-
                          {{ opt.texto }}
                          "{{ index }}"
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <template v-for="(opt1, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt1 }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <div v-if="opt.tipo === 'ABIERTA'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                          />
                        </div>

                        <template v-if="opt.tipo == 'CAMPOS'">
                          <template v-for="(opt1, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt1.texto }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>

                    <template v-if="one_question.tipo == 'CAMPOS'">
                      <template v-for="(opt, index) in one_question.campos">
                        <div class="flex w-full items-center justify-center">
                          <label
                            class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >{{ opt.texto }}</label
                          >
                          <input
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                          />
                        </div>
                      </template>
                    </template>

                    <template v-if="one_question.hasOwnProperty('subpregunta')">
                      <template
                        v-for="(opt, index) in one_question.subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.id_pregunta }}.-
                          {{ opt.texto }}
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>
                        <div v-if="opt.tipo === 'ABIERTA'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                          />
                        </div>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <template v-for="(opt, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <template v-if="opt.tipo == 'CAMPOS'">
                          <template v-for="(opt, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt.texto }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import moment from "moment";

export default {
  name: "project-detail-modal",
  data() {
    return {
      currentQuestions: {},
      currentProject: {},
      report: null,
      information: null,
      has_geometry: false,
      errors: {
        report: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      zoom: 7,
      maxZoom: 18,
      center: [20.58651, -89.01501],      
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    EventBus.$on("showProjectDetail", this.setData);
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
      });
    },

    reset: function () {
      this.geojsonRouter = null;
      (this.report = null),
        (this.information = null),
        (this.currentProject = {}),
        (this.currentQuestions = {}),
        (this.errors = {
          report: false,
          codeError: "Ha ocurrido un error",
        });
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData(data) {
      this.information = Object.assign({}, data);
      this.fetchProyect();
    },

    fetchProyect() {
      this.$root.$emit("showLoading");
      this.axios
        .get(
          `apidev/projects/getInfoProject/${this.information.id_proyecto}`,
          {},
          this.config
        )
        .then((response) => {
          //console.log(response)
          this.currentProject = response.data.answers;
          if(this.currentProject["geometria"] != null){
            this.has_geometry = true;
            this.showPolygonInMap();
          }
          else{
            this.has_geometry = false;
          }
          
          return this.axios.post(
            "apidev/projects/getFichaRespuestasJson",
            {
              id_project: this.information.id_proyecto,
            },
            this.config
          );
        })
        .then((response) => {
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => this.catchError(error));
    },

    showPolygonInMap() {
      if (this.currentProject.geometria !== null) {
        if (this.currentProject.kml != null) {
          const type = this.currentProject.kml.split(".")[1];
          if (type == "kml") {
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText);
            });
            oReq.open("GET", "apidev/" + this.currentProject.kml);
            oReq.send();
          }

          if (type == "kmz") {
            this.resetFileGeometryInMap();
            this.kmzParser.load("apidev/" + this.currentProject.kml);
          }
        } else {
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if (this.geojsonRouter) {
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            this.$refs.map.mapObject.fitBounds(boundingBox);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }
    },

    resetFileGeometryInMap() {
      if (this.layerKmz != null) {
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if (this.layerKml != null) {
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
